/* SAEGE - a colour chip beside each birthstone name.
 *
 * Twelve month names is a memory test: a customer who knows they want the
 * blue one has to already know that blue means September. The chip answers
 * the question the words cannot - colour and month in the same glance.
 *
 * HOW IT TARGETS. Only option groups whose name contains "birthstone" get
 * chips, matched on the legend text. Deliberately NOT done by the input's
 * value attribute: month names appear as plain values, and a CSS map keyed on
 * [value="June"] would also paint any future option that happens to use a
 * month - a launch month, a collection name. Reading the group name first
 * keeps it to the one place it belongs, and it picks up every birthstone
 * product automatically (the ring, the Ocean Birthstone Necklace, anything
 * added later) with no per-product setup.
 *
 * The colour is written to the label as a --saege-stone custom property and
 * drawn by CSS, so there is no extra DOM inside the label to interfere with
 * the theme's variant JS or with the selected-state fill.
 *
 * THE COLOURS BELOW ARE GENERIC GEMSTONE COLOURS, not sampled from SAEGE's
 * actual stones. They are a starting point. Anything that looks wrong next to
 * the product photography should be corrected here - this map is the single
 * place to do it.
 *
 * Styles: assets/saege-birthstone-swatch.css
 * Turn off: birthstone_swatches in snippets/saege-pdp-loader.liquid
 */
(function () {
  'use strict';

  var STONES = {
    january:   '#7c1c2c',  /* garnet - deep red */
    february:  '#6e4b9e',  /* amethyst - purple */
    march:     '#9ccfd3',  /* aquamarine - pale blue-green */
    april:     '#e6e6e6',  /* diamond - clear/white */
    may:       '#1f7a4c',  /* emerald - green */
    june:      '#9b8cc4',  /* alexandrite - light purple */
    july:      '#a0142b',  /* ruby - red */
    august:    '#9dbb48',  /* peridot - yellow-green */
    september: '#14459b',  /* sapphire - blue */
    october:   '#e6a8be',  /* opal/tourmaline - pink */
    november:  '#e0a32e',  /* citrine - amber */
    december:  '#3fafc0'   /* turquoise/blue topaz */
  };

  var started = false;

  function groupName(g) {
    var l = g.querySelector('legend.label, .label');
    return (l ? l.textContent : '').toLowerCase();
  }

  function labelText(lab) {
    var t = lab.querySelector('.opt-label__text');
    return ((t || lab).textContent || '').trim().toLowerCase();
  }

  function paint() {
    var groups = [].slice.call(
      document.querySelectorAll('.saege-ordered .option-selector')
    ).filter(function (g) { return groupName(g).indexOf('birthstone') > -1; });

    if (!groups.length) return false;

    var painted = 0;
    groups.forEach(function (g) {
      [].slice.call(g.querySelectorAll('.opt-label')).forEach(function (lab) {
        var colour = STONES[labelText(lab)];
        if (!colour) return;                       /* unknown value - no chip */
        lab.style.setProperty('--saege-stone', colour);
        lab.classList.add('saege-has-stone');
        painted++;
      });
    });
    return painted > 0;
  }

  function start() {
    if (started) return;
    if (paint()) started = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* .saege-ordered is tagged by assets/saege-pdp.js, which runs on its own
     retry loop, so the options can exist before the scope class does */
  var tries = 0;
  var iv = setInterval(function () {
    if (started || ++tries > 20) { clearInterval(iv); return; }
    start();
  }, 150);
})();
